import { ItemList } from '../../orm'
import { head } from 'lodash'

class AdminAggregatedTransactionList extends ItemList {
    getEntityKey() {
        return "transaction/totals"
    }

    invalidateTotals() {
        const totals = this.getTotals()
        if ( totals ) {
            return this.invalidateObject(totals.id)
        }
    }

    ensureTotalsLoaded() {
        return this.fetchListIfNeeded()
    }
    
    getTotals() {
        return head(this.getVisibleObjects())
    }
    
}

export const adminAggregatedTransactions = new AdminAggregatedTransactionList("admin_aggregated_transaction__default")
